import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToTimePeriodUnit } from '@modules/common/utils/mapToTimePeriodUnit';
import dayjs from 'dayjs';
import { TimeRangeResponse } from 'generated/graphql';

export const mapToDateTimeRange = (
  timeRange: TimeRangeResponse,
): DateTimeRange => {
  const { startAfter, endBefore, relative } = timeRange;

  if (relative) {
    return {
      type: 'last',
      unit: mapToTimePeriodUnit(relative.unit),
      value: relative.value,
    };
  }

  if (endBefore) {
    return {
      type: 'absolute',
      startAfter: dayjs(startAfter).tz(),
      endBefore: dayjs(endBefore).tz(),
    };
  }

  return {
    type: 'since',
    startAfter: dayjs(startAfter).tz(),
  };
};
